import Fact from '@atlassian/bitkit-analytics';

type SourceFileActionClickedFactProps = {
  label: string;
  repository_uuid: string;
  frontbucket_view: boolean;
};

type SourceHeaderActionClickedFactProps = {
  label: string;
  repository_uuid?: string;
  frontbucket_view: boolean;
};

type SourceRepoDetailsActionClickedProps = {
  label: string;
  repository_uuid: string;
  frontbucket_view: boolean;
};

export class SourceFileActionClickedFact extends Fact<SourceFileActionClickedFactProps> {
  name = 'bitbucket.repository.source_browser.file.click';
}

export class SourceHeaderActionClickedFact extends Fact<SourceHeaderActionClickedFactProps> {
  name = 'bitbucket.repository.source_browser.header.click';
}

export class SourceRepoDetailsActionClicked extends Fact<SourceRepoDetailsActionClickedProps> {
  name = 'bitbucket.repository.source_browser.repo_details.click';
}

type RepoCloneClientClickedProps = {
  client: 'Sourcetree' | 'Xcode' | 'VSCode';
  description?: string;
};

export class RepoCloneClientClicked extends Fact<RepoCloneClientClickedProps> {
  name = 'bitbucket.repository.clone_client.click';
}
